import React from 'react';
// import Typed from 'react-typed';
import SEO from "../common/SEO";
// import {Link} from "react-router-dom";
import { FiArrowRight } from "react-icons/fi";
import HeaderOne from '../common/header/HeaderOne';
// import HeaderTwo from '../common/header/HeaderTwo';
// import HeaderTopNews from '../common/header/HeaderTopNews';
// import FooterTwo from '../common/footer/FooterTwo';
// import Copyright from '../common/footer/Copyright';
import FooterThree from '../common/footer/FooterThree';
// import AboutOne from '../elements/about/AboutOne';
import ServiceFive from '../elements/service/ServiceFive';
// import CalltoActionFive from '../elements/calltoaction/CalltoActionFive';
// import TeamTwo from '../elements/team/TeamTwo';
// import TestimonialThree from "../elements/testimonial/TestimonialThree";
import SectionTitle from "../elements/sectionTitle/SectionTitle";
import Separator from "../elements/separator/Separator";
import ScrollAnimation from "react-animate-on-scroll";
// import Mission from "../elements/about/Mission";
// import BlogList from "../components/blog/itemProp/BlogList";
// import BlogClassicData from '../data/blog/BlogList.json';
// var BlogListData = BlogClassicData.slice(0, 3);

import ContactForm from "../elements/contact/ContactForm";


const Specialities = () => {
    return (
        <>
            <SEO title="Bayonne Voices For Progress" />
            <main className="page-wrapper">
                {/* <HeaderTopNews /> */}
                {/* <HeaderTwo btnStyle="round" HeaderSTyle="header-not-transparent" /> */}
                <HeaderOne btnStyle="btn-small round btn-icon" HeaderSTyle="header-not-transparent" />
   
                {/* Start Service Area  */}
                <div className="rn-service-area rn-section-gap">
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-12">
                                <SectionTitle
                                    textAlign = "text-center"
                                    radiusRounded = ""
                                    subtitle = ""
                                    title = "Get Involved!"
                                    description = "Want a lawn sign? Interested in knocking on some doors? Fill out this form below and we will get back to you as soon as possible!"
                                    />
                            </div>
                        </div>   

                <div className="our-counterup-area">
                    <div className="container">
                        <div className="row">
                        <div className="col-lg-4"></div>
                            <div className="col-lg-4">
                                <div className="thumbnail">
                                    <img className="radius w-100" src="./images/banner/bayonneBeClientDonate.jpg" alt="Images" />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                                
                        <div className="col-lg-12 col-md-6 col-12 mt_sm--40 button-container">
                            <ScrollAnimation 
                                animateIn="fadeInUp"
                                animateOut="fadeInOut"
                                animateOnce={true}
                                className="button-group mt--20">
                                    <a className="btn-default btn-extra-large btn-border btn-icon" target="blank" href="https://secure.actblue.com/donate/voices-for-progess-1">
                                        Donate via ActBlue 
                                        <i className="icon">
                                            <FiArrowRight />
                                        </i>
                                    </a>
                            </ScrollAnimation>
                        </div>   
                        
                        <div className="contact-container row mt--40 row--15">
                            <ContactForm formStyle="contact-form-1" />
                        </div>
                        {/* <ServiceFive 
                            serviceStyle = "gallery-style"
                            textAlign = "text-start"
                        /> */}
                    </div>
                </div>
                {/* End Service Area  */}

                <Separator /> 
                
                <FooterThree />
            </main>
        </>
    )
}
export default Specialities;
